import setBreakpoint from './setBreakpoint';
import getBreakpoint from './getBreakpoint';
export default {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/breakpoints/index.js
// module id = 1144
// module chunks = 168